//import React from 'react'

export default function crossParse(data_cross, transpose = false) {
	//console.log(data_cross);
	// Redatam X fix
	data_cross.data = [data_cross.data];

	const title = data_cross.metadata.title;

	// Swap dimensions: Default now shows dimensions[1] as columns, dimensions[0] as rows
	// This matches the most common use case (Y by X instead of X by Y)
	const columnDim = transpose ? data_cross.metadata.dimensions[0] : data_cross.metadata.dimensions[1];
	const rowDim = transpose ? data_cross.metadata.dimensions[1] : data_cross.metadata.dimensions[0];

	const variablesLabel = `${rowDim.label} / ${columnDim.label}`;

	const totalFields = columnDim.values.length;
	const totalRows = rowDim.values.length;

	let fieldList = [];
	let rowList = [];

	if (data_cross.metadata.areabreak) {
		const areaLabel = data_cross.metadata.areabreak.entity; //.label

		// Build fields list - Optimized: build in correct order from start
		fieldList.push(
			{ title: areaLabel, field: areaLabel },
			{ title: variablesLabel, field: 'crossJoinId' }
		);

		for (let fieldId = 0; fieldId < totalFields; fieldId++) {
			fieldList.push({
				title: columnDim.labels[fieldId].trim(),
				field: columnDim.values[fieldId],
			});
		}

		fieldList.push({ title: 'Total', field: 'rowTotal' });

		// Calculate data index adjustment for dimension swap
		// Data comes in row-major order: row0col0, row0col1, row0col2, row1col0, row1col1, row1col2, etc.
		const getDataIndex = transpose
			? (rowId, fieldId) => fieldId * totalRows + rowId
			: (rowId, fieldId) => rowId * totalFields + fieldId;

		// Loop over every area
		for (let areaId = 0; areaId < data_cross.metadata.areas.length; areaId++) {
			const areaName = data_cross.metadata.areas[areaId].label;

			// Build rows list
			for (let rowId = 0; rowId < totalRows; rowId++) {
				// Optimized: Direct property assignment instead of spread
				const row = {
					[areaLabel]: areaName,
					crossJoinId: rowDim.labels[rowId],
				};

				let rowTotal = 0;

				for (let fieldId = 0; fieldId < totalFields; fieldId++) {
					const value = data_cross.data[areaId][getDataIndex(rowId, fieldId)];
					row[columnDim.values[fieldId]] = value;

					// Sum up numeric values for the total
					if (typeof value === 'number' && !isNaN(value)) {
						rowTotal += value;
					}
				}

				row.rowTotal = rowTotal;
				rowList.push(row);
			}
		}
	} else {
		// Build fields list - Optimized: build in correct order from start
		fieldList.push({ title: variablesLabel, field: 'crossJoinId' });

		for (let fieldId = 0; fieldId < totalFields; fieldId++) {
			fieldList.push({
				title: columnDim.labels[fieldId].trim(),
				field: String(columnDim.values[fieldId]),
			});
		}

		fieldList.push({ title: 'Total', field: 'rowTotal' });

		// Calculate data index adjustment for dimension swap
		// Data comes in row-major order: row0col0, row0col1, row0col2, row1col0, row1col1, row1col2, etc.
		const getDataIndex = transpose
			? (rowId, fieldId) => fieldId * totalRows + rowId
			: (rowId, fieldId) => rowId * totalFields + fieldId;

		// Build rows list
		for (let rowId = 0; rowId < totalRows; rowId++) {
			// Optimized: Direct property assignment instead of spread
			const row = {
				crossJoinId: rowDim.labels[rowId],
			};

			let rowTotal = 0;

			for (let fieldId = 0; fieldId < totalFields; fieldId++) {
				const value = data_cross.data[0][getDataIndex(rowId, fieldId)];
				row[columnDim.values[fieldId]] = value;

				// Sum up numeric values for the total
				if (typeof value === 'number' && !isNaN(value)) {
					rowTotal += value;
				}
			}

			row.rowTotal = rowTotal;
			rowList.push(row);
		}
	}

	return {
		title: title,
		columns: fieldList,
		data: rowList,
	};
}
